import { WhatsNewEntry } from '../models/whats-new.model';

/**
 * Client-side fallback for the What's New panel — DELIBERATELY EMPTY.
 *
 * Announcements are admin-authored: the Admin portal's Announcements screen
 * manages HUB_ANNOUNCEMENTS rows that GET /agenthome/whats-new serves, and
 * WhatsNewService loads from there. The Admin portal is the SINGLE SOURCE OF
 * TRUTH. This list is used only if that endpoint is unreachable, and it is
 * empty on purpose: an unreachable service should show no panel at all rather
 * than resurrect stale, bundled entries that no admin can see or dismiss (the
 * "phantom announcements" bug). To announce a feature, add it in the Admin
 * portal — never here.
 */

/** Fallback release label for the banner chip (e.g. "Release 18"). Empty →
 *  no chip. The live value comes from the admin settings. */
export const WHATS_NEW_RELEASE_LABEL = '';

/** Fallback changelog URL for the footer link. Empty → the footer offers the
 *  quick tour instead. The live value comes from the admin settings. */
export const WHATS_NEW_CHANGELOG_URL = '';

export const WHATS_NEW_ENTRIES: WhatsNewEntry[] = [];
